module.exports = __webpack_public_path__ + "assets/clear-search.460392a7.svg";